import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=a1576580&scoped=true&"
import script from "./Tags.vue?vue&type=script&lang=ts&"
export * from "./Tags.vue?vue&type=script&lang=ts&"
import style0 from "./Tags.vue?vue&type=style&index=0&id=a1576580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1576580",
  null
  
)

export default component.exports